var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinxLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle_white",
    "data-name": "circle white",
    transform: "translate(18960 -4614)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4293",
    "data-name": "Rectangle 4293",
    width: 400,
    height: 400,
    rx: 200,
    transform: "translate(-18960 4614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2799",
    "data-name": "Group 2799",
    transform: "translate(-18878.365 4679.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_897-2",
    "data-name": "Path 897-2",
    d: "M6215.31-6042.711c0-.637-.012-1.285-.039-1.94,0-.194-.019-.4-.027-.594-.022-.485-.053-.989-.087-1.5-.014-.2-.027-.4-.043-.6q-.08-1.016-.2-2.068a2.407,2.407,0,0,0-.037-.29c-.067-.616-.153-1.244-.239-1.876-.035-.245-.074-.5-.11-.734-.075-.522-.159-1.046-.253-1.579-.041-.247-.082-.494-.125-.742q-.19-1.1-.418-2.236c-.043-.208-.092-.426-.139-.641q-.181-.86-.365-1.742l-.222-.969c-.121-.514-.245-1.03-.367-1.556-.08-.322-.159-.647-.243-.971-.2-.775-.4-1.556-.62-2.35-.1-.347-.2-.708-.3-1.059-.143-.506-.286-1.018-.437-1.532q-.184-.631-.377-1.265c-.145-.478-.29-.953-.438-1.432-.135-.432-.268-.861-.408-1.3-.255-.8-.52-1.6-.79-2.417-.169-.5-.345-1-.516-1.5-.146-.43-.3-.863-.449-1.295-.184-.539-.375-1.071-.571-1.616-.143-.4-.292-.8-.437-1.209-.463-1.265-.942-2.546-1.446-3.85-.041-.116-.084-.228-.129-.342-.243-.637-.5-1.283-.752-1.917-.139-.355-.277-.712-.42-1.071q-.395-.979-.8-1.98c-.121-.3-.247-.6-.369-.9q-1.42-3.449-3.007-7.074c-.125-.28-.247-.565-.367-.845-.345-.783-.691-1.566-1.048-2.358-.08-.184-.159-.357-.241-.535q-1.775-3.935-3.733-8.063c-.112-.234-.223-.467-.339-.7-.422-.894-.856-1.791-1.293-2.7l-.043-.09q-2.117-4.354-4.429-8.916l-.347-.684q-2.148-4.213-4.467-8.625c-.1-.191-.2-.385-.3-.575q-2.42-4.58-5.028-9.358l-.12-.223q-.888-1.627-1.795-3.27v-.012h0q-3.549-6.448-7.425-13.216c-22.273-38.945-44.864-72.361-45.091-72.694a11.97,11.97,0,0,0-11.608-5.13,11.974,11.974,0,0,0-9.689,8.2l-42.086,131.68a11.961,11.961,0,0,0,2.564,11.717c.951,1.035,94.985,103.838,103.571,113.2a11.968,11.968,0,0,0,8.82,3.874,11.937,11.937,0,0,0,5.948-1.587c1.353-.775,32.588-19.322,33.714-71.98v-.116C6215.3-6040.822,6215.31-6041.761,6215.31-6042.711Z",
    transform: "translate(-6060.114 6234.988)",
    fill: "#714dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898-2",
    "data-name": "Path 898-2",
    d: "M6292.579-6094.99,6250.5-6226.667a11.965,11.965,0,0,0-9.687-8.2,11.963,11.963,0,0,0-11.609,5.128c-.228.334-22.819,33.745-45.092,72.69l-.549.969q7.38,13.129,13.471,24.892c12.773-23.271,26.867-46.388,38.32-64.314l32.342,101.192-40.662,44.448q.37,3.736.375,7.146a129.2,129.2,0,0,1-3.894,32.136c29.594-32.344,65.916-72.045,66.5-72.691A11.956,11.956,0,0,0,6292.579-6094.99Z",
    transform: "translate(-6056.417 6234.986)",
    fill: "#714dff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinxLogoLight);
export default __webpack_public_path__ + "static/media/linx-logo-light.1c3fcad06ca5da4d3acac3ee2bb27f0c.svg";
export { ForwardRef as ReactComponent };